import { http } from '../../../../api/http';
import type { FacturaCompra } from '../types/facturaCompra.types';

export class FacturaCompraService {
  private static readonly BASE = '/compras/factura-compra';

  public static async getAll(): Promise<FacturaCompra[]> {
    const response = await http.get(this.BASE);
    return response.data;
  }

  public static async getById(id: number): Promise<FacturaCompra> {
    const response = await http.get(`${this.BASE}/${id}`);
    return response.data;
  }

  public static async save(data: FacturaCompra): Promise<FacturaCompra> {
    const response = await http.post(this.BASE, data);
    return response.data;
  }

  public static async delete(id: number): Promise<boolean> {
    await http.delete(`${this.BASE}/${id}`);
    return true;
  }

  public static async aprobar(id: number, idUsuarioAprueba: number): Promise<FacturaCompra> {
    const response = await http.post(`${this.BASE}/${id}/aprobar?idUsuarioAprueba=${idUsuarioAprueba}`);
    return response.data;
  }
}
